import React, { Component } from 'react'

class CO extends Component {
  render() {
    return (
      <symbol id="statesvg-CO" width="100" height="100" viewBox="0 0 100 100">
        <path d="M91.88,28.78l2.19,46.46-42.68.92L6.53,75.24,9,13.16,49.8,14l41.66-.67Z" />
      </symbol>
    )
  }
}

export default CO
